import { useEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

const pageMeta: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'COMMON | Residential Community Property Management',
    description: 'COMMON provides community property management for condominiums, apartment communities and planned neighborhoods, from daily operations to resident support.',
  },
  '/services': {
    title: 'Services | COMMON Community Property Management',
    description: 'Community operations, building and facility maintenance, grounds and shared spaces, resident support and administrative coordination from COMMON.',
  },
  '/communities': {
    title: 'Communities | COMMON Community Property Management',
    description: 'How COMMON supports condominium communities, apartment communities and planned residential neighborhoods, and the shared spaces residents use every day.',
  },
  '/about': {
    title: 'About | COMMON Community Property Management',
    description: 'Learn how COMMON approaches residential community management: listening first, planning realistically, managing day to day and improving each year.',
  },
  '/contact': {
    title: 'Contact | COMMON Community Property Management',
    description: 'Boards and owners can request a management proposal from COMMON. Residents can send a non-urgent support inquiry through the same contact form.',
  },
};

export default function Layout() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const meta = pageMeta[pathname] ?? pageMeta['/'];
    document.title = meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', meta.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', meta.description);
  }, [pathname]);

  useEffect(() => {
    // Back/forward: leave restoration to the browser.
    if (navType === 'POP') return undefined;
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const frame = requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ block: 'start' });
        else window.scrollTo(0, 0);
      });
      return () => cancelAnimationFrame(frame);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash, navType]);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Header />
      <main key={pathname} className="page-enter">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}